<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<div class="page-container card col-md-8">
						<ThePageHeader></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<TabView @tab-change="setIndex">
								<TabPanel>
									<template #header >
										<span>RPK</span>
									</template>

									<TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>
								</TabPanel>
								
								<TabPanel v-if="isAdmin || isHQStaff || isViewer">
									<template #header>
										<span>CWK</span>
									</template>

									<TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>
								</TabPanel>

								<TabPanel v-if="isAdmin || isHQStaff || isViewer">
									<template #header>
										<span>Journal</span>
									</template>

									<TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>
								</TabPanel>
							</TabView>
							<div class="row p-3 pb-0">
								<label><b>Search existing report by:</b></label>
							</div>
							
							<div class="row p-3 pb-0">
								<div class="col-md-6">
									<Calendar dateFormat="yy-mm-dd" selectionMode="range" :manualInput="true" placeholder="Balance Sheet Date (range)" v-model="filterBalanceSheetDateModel" />
								</div>
								
								<div class="col-md-6">
									<InputText class="p-inputtext" type="text" maxlength="50" placeholder="File ID" v-model="filterFileIdModel.value" />
								</div>
							</div>
							
							<div class="row p-3">
								<div class="col-md-6">
									<Dropdown :options="applicationStatuses" optionLabel="name" optionValue="value" placeholder="Status" v-model="filterStatusModel.value" />
								</div>

								<div v-if="activeTabIndex == 0" class="col-md-6">
									<Dropdown :options="companies" optionLabel="code" optionValue="code" filter :filterFields="['code', 'name']" showClear :placeholder="isCompanyLoading ? ('Loading...') : 'Company'" :loading="isCompanyLoading" v-model="filterCompanyModel.value">
										<template #value="slotProps">
											<div v-if="slotProps.value" class="d-flex align-items-center">
												<span class="col-md-3">{{ slotProps.value }}</span>
												<span class="col-md-9">{{ filterCompanyNameByValue(slotProps.value) }}</span>
											</div>
											<span v-else>
												{{ slotProps.placeholder }}
											</span>
										</template>

										<template #option="slotProps">
											<div class="d-flex align-items-center col-md-12">
												<span class="col-md-3">{{ slotProps.option.code }}</span>
												<span class="col-md-9">{{ slotProps.option.name }}</span>
											</div>
										</template>
									</Dropdown>
								</div>
							</div>
							
							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1, activeTabIndex)" label="Search"  :disabled="pageError != '' "/>
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" label="Reset" @click="reset" :disabled="pageError != ''" />
								</div>

								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1, activeTabIndex)" v-if="pagination.currentPage != 0" />
								</div>
							</div>
									
							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
											<tr>
												<th style="width: 5%;">#</th>
												<th style="width: 16%; cursor: pointer;" @click="sort('x.fileId')">File ID <span class="pi" :class="[sortingModel.columnName == 'x.fileId' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												
												<th v-if="activeTabIndex == 0" style="width: 25%; cursor: pointer;" @click="sort('x.companyName')">Company<span class="pi" :class="[sortingModel.columnName == 'x.companyName' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th v-if="activeTabIndex == 1 || activeTabIndex == 2" style="width: 25%; cursor: pointer;" @click="sort('x.consoGroupName')">Conso Group<span class="pi" :class="[sortingModel.columnName == 'x.consoGroupName' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												
												<th style="width: 17%; cursor: pointer;" @click="sort('x.balanceSheetDate')">Balance Sheet Date <span class="pi" :class="[sortingModel.columnName == 'x.balanceSheetDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 10%; cursor: pointer;" @click="sort('x.status')">Status <span class="pi" :class="[sortingModel.columnName == 'x.status' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 27%;" class="text-center">Action</th>
											</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
											<tr v-for="(report, index) in pagination.reports" :key="index">
												<td>{{ ((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1 }}</td>
												<td>{{ report.fileId }}</td>

												<td v-if="activeTabIndex == 0">{{ report.companyName }}</td>
												<td v-if="activeTabIndex == 1 || activeTabIndex == 2">{{ report.consoGroupName }}</td>

												<td>{{ report.balanceSheetDate }}</td>
												<td>
													<Badge class="mr-2" :class="[report.status == 'Accepted' || report.status == 'Finalised' || report.status == 'Consolidated' ? 'p-badge-success' : (report.status == 'Rejected' || report.status == 'Cancelled' ? 'p-badge-danger' : (report.status == 'Submitted' ? 'p-badge-primary' : 'p-badge-warning'))]" :value="report.status"></Badge>
												</td>
												<td class="text-right">
													<div class="row p-0">
														<div class="col-md-10 p-0">
															<Button type="button" class="p-button-sm" label="Elimination" @click="generate(report)" :disabled="isGenerateLoadingId != -1 || isExportingLoadingId != -1" v-if="report.fileId.startsWith('CW-')" />
															<span class="p-1"></span>
															<Button class="p-button-sm" icon="pi pi-external-link" label="Export" @click="exportFile(report)" :disabled="isExportingLoadingId != -1 || isGenerateLoadingId != -1" v-if="report.fileId.startsWith('RP-') || report.fileId.startsWith('CW-')"/>
															<SplitButton class="p-button-sm" icon="pi pi-file-export" label="Export" :model="getExportJournalItems(report)" :id="'splitButton'+report.fileId" @click="splitButton(report.fileId)"  v-if="report.fileId.startsWith('CJ-')"></SplitButton>
														</div>
														
														<div class="col-md-2 p-0">
															<TheLoading v-if="isExportingLoadingId == report.fileId || isGenerateLoadingId == report.fileId"></TheLoading>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<div class="error-no-record" v-if="!isLoading && pagination.reports.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>
								
								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
    import reportApi from "@/api/reporting/report-api";
	import companyApi from "@/api/company-api";
    import companyreportApi from "@/api/companyreport-api";
	import journalApi from "@/api/journal-api";
	import applicationStatusMixin from "@/mixin/application-status";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import roleMixin from "@/mixin/role";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTabViewLoading from "@/components/TheTabViewLoading.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	export default defineComponent({
		mixins: [applicationStatusMixin, dateUtilsMixin, roleMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTableLoading,
			TheTabViewLoading,
			TheLoading,
			ThePageError
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				companies: [] as any[],
				pagination: (store.getters.getCached.page == null ? {currentPage: 1, itemsPerPage: 10, reports: [], companyReports:[], totalItems: 0} : store.getters.getCached.page.pagination),
				sortingModel: (store.getters.getCached.page == null ? {columnName: "x.balanceSheetDate", isAscending: false} : store.getters.getCached.page.sortingModel),
				filterBalanceSheetDateModel: (store.getters.getCached.page == null ? null as any[] | null : store.getters.getCached.page.filterBalanceSheetDateModel),
				filterFileIdModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterFileIdModel),
				filterStatusModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterStatusModel),
				filterReportTypeModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterReportTypeModel),
				filterCompanyModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterCompanyModel),
				isLoading: false,
				isExportingLoadingId: -1,
				isGenerateLoadingId: -1,
				isCompanyLoading: false,
				activeTabIndex: 0,
			}
		},
		watch: {
			filterLegalGroup(newValue: any) {
				this.pagination = {currentPage: 1, itemsPerPage: 10, companies: [], totalItems: 0};
				this.find(1, this.activeTabIndex);

				this.loadCompanyList();
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage)
			},
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			},			
		},
		mounted: function () {
            if (this.pageError == '') {
				this.find(this.pagination.currentPage, 0);
			}

			this.loadCompanyList();
        },
		methods: {
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}

				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1, this.activeTabIndex);
			},
			find(page: number, activeTabIndex: number) {
				this.isLoading = true;
				
				store.getters.getCached.page = {
					activeTabIndex: JSON.parse(JSON.stringify(this.activeTabIndex)),
					pagination: JSON.parse(JSON.stringify(this.pagination)),
					sortingModel: JSON.parse(JSON.stringify(this.sortingModel)),
					filterBalanceSheetDateModel: this.filterBalanceSheetDateModel,
					filterFileIdModel: JSON.parse(JSON.stringify(this.filterFileIdModel)),
					filterStatusModel: JSON.parse(JSON.stringify(this.filterStatusModel)),
					filterReportTypeModel: JSON.parse(JSON.stringify(this.filterReportTypeModel)),
					filterCompanyModel: JSON.parse(JSON.stringify(this.filterCompanyModel)),
				};

				reportApi.reportFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterLegalGroupModel: {value: this.filterLegalGroup},
						filterStartBalanceSheetDateModel: {value: (this.filterBalanceSheetDateModel != null && this.filterBalanceSheetDateModel[0] != null ? this.formatToDate(this.filterBalanceSheetDateModel[0]) : null)},
						filterEndBalanceSheetDateModel: {value: (this.filterBalanceSheetDateModel != null && this.filterBalanceSheetDateModel[1] != null ? this.formatToDate(this.filterBalanceSheetDateModel[1]) : null)},
						filterFileIdModel: this.filterFileIdModel,
						filterStatusModel: this.filterStatusModel,
						filterReportTypeModel: {value: (activeTabIndex == 0 ? 'RPK' : activeTabIndex == 1 ? 'CWK' : 'journal')},
						filterCompanyModel: this.filterCompanyModel,
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, reports: response.data.rowSet, totalItems: response.data.totalItems}
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			reset() {
				this.pagination = {currentPage: 1, itemsPerPage: 10, reports: [], companyReports:[], totalItems: 0};
				this.sortingModel = {columnName: "x.balanceSheetDate", isAscending: false};
				this.filterBalanceSheetDateModel = null as any[] | null;
				this.filterFileIdModel = {value: ""};
				this.filterStatusModel = {value: null};
				this.filterReportTypeModel = {value: ""};
				this.filterCompanyModel = {value: null};
				this.find(1, this.activeTabIndex);
			},
			generate(report: any) {
				this.isGenerateLoadingId = report.fileId;
				companyreportApi.companyReportEliminationExport({}, (report.fileId.startsWith('RP-') ? 'rpk' : 'cwk'), report.identifier)
					.then(response => {
						this.isGenerateLoadingId = -1;
					})
					.catch(error => {
						this.isGenerateLoadingId = -1;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			exportFile(report: any, fileType: any = null) {
				this.isExportingLoadingId = report.fileId;
				if (report.fileId.startsWith('RP-') || report.fileId.startsWith('CW-')) {
					companyreportApi.companyReportReportExport({}, (report.fileId.startsWith('RP-') ? 'rpk' : 'cwk'), report.identifier)
						.then(response => {
							this.isExportingLoadingId = -1;
						})
						.catch(error => {
							this.isExportingLoadingId = -1;
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						});
				}
				
				else {
					journalApi.journalReportExport({"fileType": fileType}, report.identifier)
						.then(response => {
							this.isExportingLoadingId = -1;
						})
						.catch(error => {
							this.isExportingLoadingId = -1;
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						});
				}
			},
			setIndex(event: any){
				this.activeTabIndex = event.index
				this.find(1, event.index)
			},
			loadCompanyList() {
				this.filterCompanyModel = {value: null}
						
				this.isCompanyLoading = true;
				companyApi.companyList({isSheetDialog: true}, this.filterLegalGroup == null ? null : this.filterLegalGroup.identifier)
					.then(response => {
						this.companies = response.data.listSet;
						this.isCompanyLoading = false;
					})
					.catch(error => {
						this.isCompanyLoading = false;
					});
			},
			filterCompanyNameByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.code == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].name;
				}
				return null;
			},
			splitButton(fileId: any) {
				var splitButton = document.getElementById('splitButton'+fileId)?.getElementsByClassName('p-splitbutton-menubutton')[0] as HTMLElement;
				splitButton.click();
			},
			getExportJournalItems(report: any) {
				return [
				{
					label: 'Excel',
					icon: 'pi pi-file-excel',
					command: () => this.exportFile(report, 'excel')
				},
				{
					label: 'PDF',
					icon: 'pi pi-file-pdf',
					command: () => this.exportFile(report, 'pdf')
				}
				];
			},
		},
	});
</script>